var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6B2629",
    fillRule: "evenodd",
    d: "M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15M.833 10a9.167 9.167 0 1 1 18.334 0A9.167 9.167 0 0 1 .833 10",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6B2629",
    fillRule: "evenodd",
    d: "M10 9.167c.46 0 .833.373.833.833v3.333a.833.833 0 1 1-1.666 0V10c0-.46.373-.833.833-.833",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6B2629",
    d: "M10.833 6.667a.833.833 0 1 1-1.666 0 .833.833 0 0 1 1.666 0"
  })));
};
export default SvgWarning;